import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const HomePage = () => import('../views/HomePage')
const AboutPage = () => import('../views/about')
const ProductsHub = () => import('../views/products')
const ProductSeries = () => import('../views/ProductSeries')
const link = () => import('../views/link')
const Case = () => import('../views/case')
const Oil = () => import('../views/OilProduct')
const Water = () => import('../views/WaterProduct')
const Join = () => import('../views/join')

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: [
    { path: '/', component: HomePage },
    { path: '/about', name: 'AboutPage', component: AboutPage },
    { path: '/products', name: 'ProductsHub', component: ProductsHub },
    {
      path: '/products/:slug',
      name: 'ProductSeries',
      component: ProductSeries,
      props: (route) => ({ slug: route.params.slug })
    },
    { path: '/link', name: 'LinkPage', component: link },
    { path: '/case', name: 'CasePage', component: Case },
    { path: '/oil', name: 'OilPage', component: Oil },
    { path: '/water', name: 'WaterPage', component: Water },
    { path: '/join', name: 'JoinPage', component: Join }
  ]
})

export default router
